/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ContractorBriefDto } from '../models';
// @ts-ignore
import { CreateProjectCommand } from '../models';
// @ts-ignore
import { ProjectClientDto } from '../models';
// @ts-ignore
import { ProjectDetailsDto } from '../models';
// @ts-ignore
import { ProjectDtoPaginatedList } from '../models';
// @ts-ignore
import { ProjectStatisticsDto } from '../models';
// @ts-ignore
import { ProjectUnitsForDealDto } from '../models';
// @ts-ignore
import { UpdateProjectCommand } from '../models';
/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsGet: async (pageNumber?: number, pageSize?: number, searchTerm?: string, isActive?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdClientsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsIdClientsGet', 'id', id)
            const localVarPath = `/api/Projects/{id}/clients`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdContractorsGet: async (id: number, activeOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsIdContractorsGet', 'id', id)
            const localVarPath = `/api/Projects/{id}/contractors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsIdDelete', 'id', id)
            const localVarPath = `/api/Projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsIdGet', 'id', id)
            const localVarPath = `/api/Projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateProjectCommand} [updateProjectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdPut: async (id: number, updateProjectCommand?: UpdateProjectCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsIdPut', 'id', id)
            const localVarPath = `/api/Projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProjectCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdStatisticsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsIdStatisticsGet', 'id', id)
            const localVarPath = `/api/Projects/{id}/statistics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdUnitsForDealGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsIdUnitsForDealGet', 'id', id)
            const localVarPath = `/api/Projects/{id}/units-for-deal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateProjectCommand} [createProjectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsPost: async (createProjectCommand?: CreateProjectCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProjectCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, isActive?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsGet(pageNumber, pageSize, searchTerm, isActive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsIdClientsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectClientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsIdClientsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsIdContractorsGet(id: number, activeOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorBriefDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsIdContractorsGet(id, activeOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateProjectCommand} [updateProjectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsIdPut(id: number, updateProjectCommand?: UpdateProjectCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsIdPut(id, updateProjectCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsIdStatisticsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsIdStatisticsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsIdUnitsForDealGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectUnitsForDealDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsIdUnitsForDealGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateProjectCommand} [createProjectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsPost(createProjectCommand?: CreateProjectCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsPost(createProjectCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, isActive?: boolean, options?: any): AxiosPromise<ProjectDtoPaginatedList> {
            return localVarFp.apiProjectsGet(pageNumber, pageSize, searchTerm, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdClientsGet(id: number, options?: any): AxiosPromise<Array<ProjectClientDto>> {
            return localVarFp.apiProjectsIdClientsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdContractorsGet(id: number, activeOnly?: boolean, options?: any): AxiosPromise<Array<ContractorBriefDto>> {
            return localVarFp.apiProjectsIdContractorsGet(id, activeOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProjectsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdGet(id: number, options?: any): AxiosPromise<ProjectDetailsDto> {
            return localVarFp.apiProjectsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateProjectCommand} [updateProjectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdPut(id: number, updateProjectCommand?: UpdateProjectCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiProjectsIdPut(id, updateProjectCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdStatisticsGet(id: number, options?: any): AxiosPromise<ProjectStatisticsDto> {
            return localVarFp.apiProjectsIdStatisticsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsIdUnitsForDealGet(id: number, options?: any): AxiosPromise<ProjectUnitsForDealDto> {
            return localVarFp.apiProjectsIdUnitsForDealGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateProjectCommand} [createProjectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsPost(createProjectCommand?: CreateProjectCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiProjectsPost(createProjectCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiProjectsGet operation in ProjectsApi.
 * @export
 * @interface ProjectsApiApiProjectsGetRequest
 */
export interface ProjectsApiApiProjectsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectsApiApiProjectsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof ProjectsApiApiProjectsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ProjectsApiApiProjectsGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {boolean}
     * @memberof ProjectsApiApiProjectsGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for apiProjectsIdClientsGet operation in ProjectsApi.
 * @export
 * @interface ProjectsApiApiProjectsIdClientsGetRequest
 */
export interface ProjectsApiApiProjectsIdClientsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectsApiApiProjectsIdClientsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiProjectsIdContractorsGet operation in ProjectsApi.
 * @export
 * @interface ProjectsApiApiProjectsIdContractorsGetRequest
 */
export interface ProjectsApiApiProjectsIdContractorsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectsApiApiProjectsIdContractorsGet
     */
    readonly id: number

    /**
     * 
     * @type {boolean}
     * @memberof ProjectsApiApiProjectsIdContractorsGet
     */
    readonly activeOnly?: boolean
}

/**
 * Request parameters for apiProjectsIdDelete operation in ProjectsApi.
 * @export
 * @interface ProjectsApiApiProjectsIdDeleteRequest
 */
export interface ProjectsApiApiProjectsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectsApiApiProjectsIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiProjectsIdGet operation in ProjectsApi.
 * @export
 * @interface ProjectsApiApiProjectsIdGetRequest
 */
export interface ProjectsApiApiProjectsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectsApiApiProjectsIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiProjectsIdPut operation in ProjectsApi.
 * @export
 * @interface ProjectsApiApiProjectsIdPutRequest
 */
export interface ProjectsApiApiProjectsIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectsApiApiProjectsIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateProjectCommand}
     * @memberof ProjectsApiApiProjectsIdPut
     */
    readonly updateProjectCommand?: UpdateProjectCommand
}

/**
 * Request parameters for apiProjectsIdStatisticsGet operation in ProjectsApi.
 * @export
 * @interface ProjectsApiApiProjectsIdStatisticsGetRequest
 */
export interface ProjectsApiApiProjectsIdStatisticsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectsApiApiProjectsIdStatisticsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiProjectsIdUnitsForDealGet operation in ProjectsApi.
 * @export
 * @interface ProjectsApiApiProjectsIdUnitsForDealGetRequest
 */
export interface ProjectsApiApiProjectsIdUnitsForDealGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectsApiApiProjectsIdUnitsForDealGet
     */
    readonly id: number
}

/**
 * Request parameters for apiProjectsPost operation in ProjectsApi.
 * @export
 * @interface ProjectsApiApiProjectsPostRequest
 */
export interface ProjectsApiApiProjectsPostRequest {
    /**
     * 
     * @type {CreateProjectCommand}
     * @memberof ProjectsApiApiProjectsPost
     */
    readonly createProjectCommand?: CreateProjectCommand
}

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     * 
     * @param {ProjectsApiApiProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public apiProjectsGet(requestParameters: ProjectsApiApiProjectsGetRequest = {}, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsIdClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public apiProjectsIdClientsGet(requestParameters: ProjectsApiApiProjectsIdClientsGetRequest, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsIdClientsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsIdContractorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public apiProjectsIdContractorsGet(requestParameters: ProjectsApiApiProjectsIdContractorsGetRequest, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsIdContractorsGet(requestParameters.id, requestParameters.activeOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public apiProjectsIdDelete(requestParameters: ProjectsApiApiProjectsIdDeleteRequest, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public apiProjectsIdGet(requestParameters: ProjectsApiApiProjectsIdGetRequest, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public apiProjectsIdPut(requestParameters: ProjectsApiApiProjectsIdPutRequest, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsIdPut(requestParameters.id, requestParameters.updateProjectCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsIdStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public apiProjectsIdStatisticsGet(requestParameters: ProjectsApiApiProjectsIdStatisticsGetRequest, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsIdStatisticsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsIdUnitsForDealGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public apiProjectsIdUnitsForDealGet(requestParameters: ProjectsApiApiProjectsIdUnitsForDealGetRequest, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsIdUnitsForDealGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectsApiApiProjectsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public apiProjectsPost(requestParameters: ProjectsApiApiProjectsPostRequest = {}, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsPost(requestParameters.createProjectCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
